import { render, staticRenderFns } from "./TransferTemplate.vue?vue&type=template&id=4e130232&scoped=true&"
import script from "./TransferTemplate.vue?vue&type=script&lang=js&"
export * from "./TransferTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TransferTemplate.vue?vue&type=style&index=0&id=4e130232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e130232",
  null
  
)

export default component.exports